
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { ApiAccessMetaData } from "@/models/module-api-access-meta-data";
import { PlanModule } from "@/models/plan-module";

export default FormLike.extend({
	data() {
		return {
			maxApiCalls: 0,
		};
	},
	props: {
		value: {
			type: Object as () => PlanModule,
			required: true,
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.maxApiCalls = ApiAccessMetaData.create(this.value.MetaData).getMaxApiCalls();
			},
		},
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		confirm() {
			if (!this.isValid) return;
			ApiAccessMetaData.create(this.value.MetaData).setMaxApiCalls(this.maxApiCalls);
			this.$emit("close");
		},
	},
});
